import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const SwitcherViewType = props => {
  const { changeView, documentView } = props;

  return (
    <div style={{ display: "flex" }}>
      <div
        className={
          documentView === "list"
            ? "iconTypeGrid gs-documents-view-list left active"
            : "iconTypeGrid gs-documents-view-list left"
        }
        onClick={() => changeView("list")}
      >
        <FontAwesomeIcon
          icon={["far", "list"]}
          style={{
            fontSize: 16,
            marginRight: "8px"
          }}
        />
      </div>
      <div
        className={
          documentView === "grid"
            ? "iconTypeGrid gs-documents-view-th right active"
            : "iconTypeGrid gs-documents-view-th right"
        }
        onClick={changeView.bind(this, "grid")}
      >
        <FontAwesomeIcon
          icon={["fas", "th"]}
          style={{
            fontSize: 16,
            marginRight: "8px"
          }}
        />
      </div>
    </div>
  );
};

export default SwitcherViewType;
